import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {OpenBadge} from '@modules/achievement/core/services/user-score.service';
import {DataEntity, OctopusConnectService} from 'octopus-connect';
import {take} from 'rxjs/operators';
import {AuthenticationService} from '@modules/authentication';
import {FuseConfirmDialogComponent} from 'fuse-core/components/confirm-dialog/confirm-dialog.component';
import {TranslateService} from '@ngx-translate/core';

@Component({
    templateUrl: './open-badge-dialog.component.html',
    standalone: false
})
export class OpenBadgeDialog {
    constructor(@Inject(MAT_DIALOG_DATA) public data: OpenBadge,
                private dialog: MatDialog,
                private octopusConnect: OctopusConnectService,
                private auth: AuthenticationService,
                private translate: TranslateService) {
        this.data = data['attributes'];
        this.data.id = data.id;
    }

    downloadBadgeImageWithEmail(): void {
        const data = {
            titleDialog: 'openbadge.download_badge',
            bodyDialog: 'openbadge.add_email',
            labelConfirmDialog: 'generic.validate',
            labelConfirmDialogPlaceHolder: 'openbadge.email_placeholder',
        };
        for (const myField in data) {
            if (data[myField] !== '') {
                this.translate.get(data[myField]).subscribe((translation: string) => data[myField] = translation);
            }
        }
        data['inputValue'] = '';
        data['autofocus'] = true;
        data['validator'] = (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);


        const dialogRef = this.dialog.open(FuseConfirmDialogComponent, {
            width: '400px',
            data,
        });

        dialogRef.afterClosed().subscribe((email: string) => {
            if (!email) {
                return;
            }

            this.generateBadgeAndDownload(email);
        });
    }

    generateBadgeAndDownload(email: string): void {
        this.octopusConnect.createEntity('openbadges', {
            achievement_id: this.data.id,
            email
        }).pipe(
            take(1)
        ).subscribe({
            next: async (res: any) => {
                const badgeUrl = res?.get?.('badge') ?? res?.data?.[0]?.badge;

                if (!badgeUrl) {
                    console.error('Pas de badge retourne');
                    return;
                }

                await this.downloadBadgeImage(badgeUrl);
            },
            error: (err) => {
                console.error('Erreur API', err);
            }
        });
    }

    async downloadBadgeImage(url: string) {
        // ?t to force a new version and bypass cache
        const image = await fetch(`${url}?t=${Date.now()}`);
        const imageBlog = await image.blob();
        const imageURL = URL.createObjectURL(imageBlog);

        const link = document.createElement('a');
        link.href = imageURL;
        link.download = `${this.data.name}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    downloadCertificateWithName(): void {
        const data = {
            titleDialog: 'openbadge.download_certificate',
            bodyDialog: 'openbadge.add_name',
            labelConfirmDialog: 'generic.validate',
            labelConfirmDialogPlaceHolder: 'openbadge.name_placeholder',
        };
        for (const myField in data) {
            if (data[myField] !== '') {
                this.translate.get(data[myField]).subscribe((translation: string) => data[myField] = translation);
            }
        }
        data['inputValue'] = '';
        data['autofocus'] = true;

        const dialogRef = this.dialog.open(FuseConfirmDialogComponent, {
            width: '400px',
            data
        });

        dialogRef.afterClosed().subscribe((name: string) => {
            if (!name) {
                return;
            }
            this.downloadBadgeCertificate(name);
        });

    }

    public downloadBadgeCertificate(name: string): void {
        const idWithQuery = `${this.data.id}?name=${encodeURIComponent(name)}`;
        this.octopusConnect.loadEntity('openbadges-awards-pdf', idWithQuery)
            .pipe(take(1))
            .subscribe((data: DataEntity) => {
                // ?t to force a new version and bypass cache
                window.open(`${data.get('pdf')}?t=${Date.now()}`, '_blank');
            });
    }

    public get isGar(): boolean {
        return this.auth.isGAR();
    }
}